import {React, useState,useEffect} from 'react';
import {Placeholder} from 'react-bootstrap';
import { useParams } from "react-router-dom";
import '../css/product.css';

import {Api} from '../component/api';
import Breadcrumb from "../component/Breadcrumb";
import ProductDetail from "../component/ProductDetail"
import FreeShipping from "../component/freeshipping";

function ProductPage({ productId }) {
    const [data, setData] = useState({
        name: "",
        images:[],
        groups:{},
        product_url :"",
        breadcrumb: {},
        webhesab_ojrate: {ojrat: 18},
        webhesab_addition_info:{}
    });
    const [loading, setLoading] = useState(false); 

    async function fetchData(productId,nextPage=0) {

        if(!productId)
        {
            return;
        }
        setLoading(true);
        try {
            const response = await Api("productdetail",{product_id: productId});
            if(response.success==true){
                /*setData((prevData) => ({
                    ...prevData, // نگه داشتن داده‌های فعلی
                    ...response.psdata, // به‌روزرسانی تمامی داده‌ها با پاسخ جدید
                    products: [...prevData.products, ...response.psdata.products], // ترکیب محصولات قبلی و جدید
                }));*/
                setData(response.psdata);
            }
        } catch (error) {
            console.error("API Error:", error);
        } 
        finally {
            setLoading(false); // پایان بارگذاری
        }
    }
    useEffect(() => {
        fetchData(productId);
    }, [productId]);
  
    let breadcrumbs = [
        ...Object.values(data.breadcrumb).slice(1).map(bc => ({
            link: bc.url.replace(global.config.domain_url, ""),
            name: bc.title,
        })),
        { link: data.product_url.replace(global.config.domain_url, ""), name: data.name }
    ];
   
    return (
        <div>
            <div id="product">
                {loading?
                    (
                        <>
                            <nav className='breadcrumb-section container' aria-label="breadcrumb-1">
                                <Placeholder className="breadcrumb" animation="glow">
                                    <Placeholder xs={2} />
                                </Placeholder>
                            </nav>
                        </>
                    ):       
                    (
                        <>
                            <Breadcrumb path={breadcrumbs}/>
                        </>
                    )
                }

                <ProductDetail 
                    Product = {data} 
                    loading = {loading}
                />
                
                <FreeShipping />
            </div>
        </div>
    );
};

export default ProductPage;